import React from "react";
import { Input } from "antd";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import PropTypes from "prop-types";

const { Search } = Input;

const SearchArchive = (props) => {
  // eslint-disable-next-line
  const { showSearchResult, setShowSearchResult, inputName = "search" } = props;

  const history = useHistory();
  const { url } = useRouteMatch();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  return (
    <div
      className="ArchiveSearch"
      onClick={(event) => setShowSearchResult(!showSearchResult)}
    >
      <Search
        defaultValue={searchParams.get(inputName)}
        enterButton
        addonBefore={""}
        size="large"
        placeholder="جستجو..."
        allowClear={true}
        onSearch={(value) => {
          history.push({
            pathname: `${url}`,
            search: value ? `?${inputName}=${encodeURIComponent(value)}` : null,
          });
        }}
      />
    </div>
  );
};

SearchArchive.propTypes = {
  showSearchResult: PropTypes.bool,
  setSearchResult: PropTypes.func,
  apiResponse: PropTypes.object,
};

export default SearchArchive;
